import React from "react";
import bannerImage from "../assets/images/aboutimg.jpg";
import "../assets/css/style.css";

const VideoBanner = () => {
  return (
    <div className="video-banner">
      <img src={bannerImage} alt="Invest in a better tomorrow" />
    </div>
  );
};

export default VideoBanner;
